import React from "react";
import Header from "../Header";
import Game from "../Game";
import ArchivePage from "../ArchivePage";

import { Toaster } from "../ui/toaster";
import PuzzleDataProvider from "../../providers/PuzzleDataProvider";
import GameStatusProvider from "../../providers/GameStatusProvider";
import { ThemeProvider } from "../../providers/ThemeProvider";

function App() {
  const search = typeof window !== "undefined" ? window.location.search : "";
  const isArchivePage =
    new URLSearchParams(search).get("page") === "archive";

  return (
    <ThemeProvider>
      <PuzzleDataProvider>
        <div className="wrapper">
          <Toaster />
          <Header />
          {isArchivePage ? (
            <ArchivePage />
          ) : (
            <GameStatusProvider>
              <Game />
            </GameStatusProvider>
          )}
        </div>
      </PuzzleDataProvider>
    </ThemeProvider>
  );
}

export default App;
